<template>
  <div class="totalProduceTime table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      總生產時間
      <!-- <span>{{ totalProduceTiming }}</span> -->
    </li>
    <b-table
      :items="totalProduceTimeItem"
      :fields="totalProduceTimeFields"
      class="text-center totalProduceTime-table-detail"
    >
      <template #cell(code)="data">
        {{ data.item.code }}
        <span style="color: #c10000">
          {{ data.item.rework ? "(重工)" : "" }}
          <!-- {{
            data.item.rework && data.item.ht_in_process !== "-"
              ? "(" + data.item.ht_in_process + "重工)"
              : ""
          }} -->
        </span>
      </template>
      <template #cell(startTime)="data">
        {{ data.value.split(".")[0] }}
      </template>
      <template #cell(endTime)="data">
        {{ data.value.split(".")[0] }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "totalProduceTime",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      totalProduceTimeFields: "totalProduceTime/get_totalProduceTimeFields",
      totalProduceTimeItem: "totalProduceTime/get_totalProduceTimeItem",
      totalProduceTiming: "totalProduceTime/get_totalProduceTiming",
    }),
  },
};
</script>

<style lang="scss">
.totalProduceTime-table-detail thead th {
  border-top: 1px solid;
}
.totalProduceTime-table-detail th,
.totalProduceTime-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.totalProduceTime-table-detail th:first-child,
.totalProduceTime-table-detail td:first-child {
  border-left: 1px solid;
}
.totalProduceTime-table-detail {
  margin-bottom: 0px;
}
.totalProduceTime-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.totalProduceTime-table-detail tr td {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/totalProduceTime.vue